(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9225],{

/***/ 53766:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tou/guest",
      function () {
        return __webpack_require__(30097);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 30097:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(35944);
/* harmony import */ var _components_common_Template__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(33431);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70917);
/* harmony import */ var plume_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4807);
/* harmony import */ var _components_pages_tou_TouMarkdown__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59621);
/* harmony import */ var _components_common_Head__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12912);






function GuestTouPage(param) {
    var markdown = param.markdown;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)(_components_common_Template__WEBPACK_IMPORTED_MODULE_0__/* .Template */ .Y, {
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_components_common_Head__WEBPACK_IMPORTED_MODULE_3__/* .DefaultHead */ .UJ, {
                title: "利用規約 - スピーダ スタートアップ情報リサーチ"
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("div", {
                css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)("display:flex;justify-content:center;align-items:center;padding:40px 40px 24px;background:", plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .colors.gray30 */ .O9.gray30, ";height:200px;", plume_ui__WEBPACK_IMPORTED_MODULE_1__.mq.untilMedium, "{height:128px;padding:24px 24px 16px;}"),
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("div", {
                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("h1", {
                        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)("font-size:42px;text-align:center;line-height:1.5;margin:0 0 8px 0;letter-spacing:0.01em;", plume_ui__WEBPACK_IMPORTED_MODULE_1__.mq.untilMedium, "{font-size:24px;}"),
                        "data-testid": "tou-title",
                        children: "利用規約"
                    })
                })
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("div", {
                css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)("display:flex;justify-content:center;"),
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("div", {
                    css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)("padding:64px 0 40px 0;max-width:928px;", plume_ui__WEBPACK_IMPORTED_MODULE_1__.mq.untilMedium, "{padding:40px 24px;}"),
                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_components_pages_tou_TouMarkdown__WEBPACK_IMPORTED_MODULE_2__/* .TouMarkdown */ .i, {
                        children: markdown.value
                    })
                })
            })
        ]
    });
}
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (GuestTouPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [8687,519,774,3431,3528,9774,2888,179], function() { return __webpack_exec__(53766); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);